<div class="multi-subscription-news-warning">
  <p class="headline-3">{{ "NOTIFICATION_SERVICE.EDIT.NEWS.MULTI_WARNING.header" | translate }}</p>
  <p class="body-2">{{ "NOTIFICATION_SERVICE.EDIT.NEWS.MULTI_WARNING.bodyTop" | translate }}</p>
  <p class="body-2">{{ "NOTIFICATION_SERVICE.EDIT.NEWS.MULTI_WARNING.bodyBottom" | translate }}</p>
</div>
